module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "lista-solicitud-vacaciones contenedor-interno"
  }, [_vm._m(0), (_vm.mostrarModalEliminar) ? _c('transition', {
    attrs: {
      "name": "fade",
      "tag": "div"
    }
  }, [_c('confirmar-accion-overlay', {
    ref: "confirmarEliminar",
    on: {
      "close": _vm.closeModalEliminar,
      "do": _vm.eliminar
    }
  }, [_c('span', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("¿Desea eliminar el contrato?")]), _c('span', {
    attrs: {
      "slot": "primaryAction"
    },
    slot: "primaryAction"
  }, [(_vm.isProcessing) ? _c('span', [_vm._v("Eliminando...")]) : _c('span', [_vm._v("Eliminar")])]), _c('strong', [_vm._v("Este proceso no se puede deshacer")])])], 1) : _vm._e(), (_vm.mostrarModalNotificar) ? _c('transition', {
    attrs: {
      "name": "fade",
      "tag": "div"
    }
  }, [_c('confirmar-accion-overlay', {
    ref: "confirmarNotificar",
    on: {
      "close": _vm.closeModalNotificar,
      "do": _vm.notificar
    }
  }, [_c('span', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("¿Desea notificar a todos los empleados que no hayan firmado?")]), _c('span', {
    attrs: {
      "slot": "primaryAction"
    },
    slot: "primaryAction"
  }, [(_vm.isProcessing) ? _c('span', [_vm._v("Notificando...")]) : _c('span', [_vm._v("Notificar")])]), _c('strong', [_vm._v("Este proceso no se puede deshacer")])])], 1) : _vm._e(), _c('transition-group', {
    staticClass: "contenedor-box-transition",
    attrs: {
      "name": "fade-smooth-two",
      "tag": "div"
    }
  }, [_c('div', {
    key: "filtros-container",
    staticClass: "filtros-container"
  }, [_c('transition-group', {
    staticClass: "contenedor-box-transition",
    attrs: {
      "name": "fade-smooth-two",
      "tag": "div"
    }
  }, [_c('div', {
    key: "title-filtro",
    staticClass: "title-filtro",
    class: {
      'hide-box-shadow': !_vm.mostrarFiltros
    },
    on: {
      "click": function($event) {
        _vm.mostrarFiltros = !_vm.mostrarFiltros
      }
    }
  }, [_c('h2', {
    staticClass: "text"
  }, [_vm._v("filtros")]), _c('div', {
    staticClass: "caret"
  }, [_c('span', {
    staticClass: "icon"
  }, [(_vm.mostrarFiltros) ? _c('i', {
    staticClass: "fa fa-caret-down"
  }) : _c('i', {
    staticClass: "fa fa-caret-up"
  })])])]), (_vm.mostrarFiltros) ? _c('div', {
    key: "filtros",
    staticClass: "filtros"
  }, [(_vm.perfil === 'recursos humanos') ? _c('div', {
    staticClass: "filtro"
  }, [_c('div', {
    staticClass: "codigo-empleado"
  }, [_c('div', {
    staticClass: "control title-singular"
  }, [_c('p', [_vm._v("Empleado")]), _c('div', {
    staticClass: "input-container"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filtros.codigoEmpleado),
      expression: "filtros.codigoEmpleado"
    }],
    staticClass: "input",
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.filtros.codigoEmpleado)
    },
    on: {
      "focus": function($event) {
        _vm.mostrarBusquedaEmpleado = true
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filtros, "codigoEmpleado", $event.target.value)
      }
    }
  }), _c('span', {
    staticClass: "icon cursor-pointer margin-left-5",
    on: {
      "click": function($event) {
        _vm.mostrarBusquedaEmpleado = true
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  })]), _c('div', {
    staticClass: "erase-data",
    on: {
      "click": function($event) {
        _vm.filtros.codigoEmpleado = ''
      }
    }
  }, [_c('div', {
    staticClass: "icon"
  }, [_c('div', {
    staticClass: "fa fa-times"
  })])])])]), _c('transition', {
    attrs: {
      "name": "fade-quick"
    }
  }, [(_vm.mostrarBusquedaEmpleado) ? _c('div', {
    staticClass: "pop-over"
  }, [_c('lookup-small-empleado', {
    attrs: {
      "codigo": _vm.filtros.codigoEmpleado
    },
    on: {
      "selected": _vm.seleccionarEmpleado,
      "close": function($event) {
        _vm.mostrarBusquedaEmpleado = false
      }
    }
  })], 1) : _vm._e()])], 1)]) : _vm._e(), _c('div', {
    staticClass: "filtro"
  }, [_c('div', {
    staticClass: "control title-singular"
  }, [_c('p', [_vm._v("Fecha finalización desde")]), _c('div', {
    staticClass: "input-container display-flex"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filtros.desde),
      expression: "filtros.desde"
    }],
    staticClass: "input",
    attrs: {
      "type": "date"
    },
    domProps: {
      "value": (_vm.filtros.desde)
    },
    on: {
      "blur": _vm.changeFecha,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filtros, "desde", $event.target.value)
      }
    }
  })])])]), _c('div', {
    staticClass: "filtro"
  }, [_c('div', {
    staticClass: "control title-singular"
  }, [_c('p', [_vm._v("Fecha finalización hasta")]), _c('div', {
    staticClass: "input-container display-flex"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filtros.hasta),
      expression: "filtros.hasta"
    }],
    staticClass: "input",
    attrs: {
      "type": "date"
    },
    domProps: {
      "value": (_vm.filtros.hasta)
    },
    on: {
      "blur": _vm.changeFecha,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filtros, "hasta", $event.target.value)
      }
    }
  })])])]), _c('div', {
    staticClass: "filtro"
  }, [_c('div', {
    staticClass: "title-singular"
  }, [_c('p', [_vm._v("¿Firmado?")])]), _c('div', {
    staticClass: "select display-flex"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filtros.firmado),
      expression: "filtros.firmado"
    }],
    staticClass: "flex-1",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.filtros, "firmado", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, _vm.changeFiltro]
    }
  }, [_c('option', {
    attrs: {
      "value": "all"
    }
  }, [_vm._v("Todos")]), _c('option', {
    domProps: {
      "value": 1
    }
  }, [_vm._v("Si")]), _c('option', {
    domProps: {
      "value": 0
    }
  }, [_vm._v("No")])])])]), _c('div', {
    staticClass: "filtro"
  }, [_c('div', {
    staticClass: "title-singular"
  }, [_c('p', [_vm._v("¿Indeterminado?")])]), _c('div', {
    staticClass: "select display-flex"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filtros.indeterminado),
      expression: "filtros.indeterminado"
    }],
    staticClass: "flex-1",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.filtros, "indeterminado", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, _vm.changeIndeterminado]
    }
  }, [_c('option', {
    attrs: {
      "value": "all"
    }
  }, [_vm._v("Todos")]), _c('option', {
    domProps: {
      "value": 1
    }
  }, [_vm._v("Si")]), _c('option', {
    domProps: {
      "value": 0
    }
  }, [_vm._v("No")])])])])]) : _vm._e(), _c('div', {
    key: "boton-container",
    staticClass: "boton-container"
  }, [_c('button', {
    staticClass: "button",
    on: {
      "click": _vm.fetch
    }
  }, [_c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-refresh fa-fw fa-lg"
  })]), _c('span', [_vm._v("Refrescar")])]), _c('button', {
    staticClass: "button",
    on: {
      "click": _vm.limpiarFiltros
    }
  }, [_c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-trash fa-fw fa-lg"
  })]), _c('span', [_vm._v("Limpiar")])]), _c('button', {
    staticClass: "button is-primary margin-button-top",
    on: {
      "click": _vm.openModalNotificacionMasiva
    }
  }, [_c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-envelope fa-fw fa-lg"
  })]), _c('span', [_vm._v("Notificar a todos los filtrados")])])])])], 1), _c('div', {
    key: "body",
    staticClass: "body"
  }, [(_vm.isLoading) ? _c('div', {
    staticClass: "is-loading"
  }, [_c('div', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-spinner fa-spin"
  })])]) : _c('div', {
    staticClass: "information"
  }, [(_vm.lista.length !== 0) ? _c('table', {
    staticClass: "table is-striped is-bordered"
  }, [_c('thead', [_c('th', [_vm._v("Empleado")]), _c('th', {
    staticClass: "hide-break-1"
  }, [_vm._v("Duracion")]), _c('th', {
    staticClass: "hide-break-1"
  }, [_vm._v("Firmado")]), (_vm.perfil === 'recursos humanos') ? _c('th') : _vm._e()]), _c("transition-group", {
    tag: "tbody",
    attrs: {
      "name": "table-row"
    }
  }, _vm._l((_vm.lista), function(o, index) {
    return _c('tr', {
      key: index,
      staticClass: "row-table"
    }, [_c('td', [_c('div', {
      staticClass: "td-wrapper hint--bottom",
      attrs: {
        "aria-label": 'Contrato: ' + o.id
      }
    }, [_c('span', {
      staticClass: "hint--top",
      attrs: {
        "aria-label": 'Empleado: ' + o.dniEmpleado
      }
    }, [_vm._v(_vm._s(o.nombreEmpleado))]), _c('div', {
      staticClass: "show-break-1 dates-wrapper"
    }, [_c('span', {
      staticClass: "has-text-bold"
    }, [_vm._v("Duracion: ")]), _c('span', [_vm._v(_vm._s(o.indeterminado ? 'Indeterminado' : o.fechaInicio + ' - ' + o.fechaFin))])]), (o.pathFirmado) ? [_c('div', {
      staticClass: "show-break-1 seen"
    }, [_c('span', {
      staticClass: "has-text-bold"
    }, [_vm._v("Firmado")]), _c('span', {
      staticClass: "icon"
    }, [_c('i', {
      staticClass: "fa fa-check fs-12"
    })])]), _c('div', {
      staticClass: "show-break-1 dates-wrapper"
    }, [_c('span', {
      staticClass: "has-text-bold"
    }, [_vm._v("Fecha de firma: ")]), _c('span', [_vm._v(_vm._s(o.fechaFirma))])])] : _vm._e()], 2)]), _c('td', {
      staticClass: "hide-break-1"
    }, [(o.indeterminado) ? _c('span', [_vm._v("Indeterminado")]) : _vm._e(), (!o.indeterminado) ? _c('div', {
      staticClass: "wrapper"
    }, [_c('span', [_vm._v(_vm._s(o.fechaInicio) + " - " + _vm._s(o.fechaFin))])]) : _vm._e(), (o.fechaFirma) ? _c('div', {
      staticClass: "dates-wrapper"
    }, [_c('span', {
      staticClass: "has-text-bold"
    }, [_vm._v("Fecha de firma: ")]), _c('span', [_vm._v(_vm._s(o.fechaFirma))])]) : _vm._e()]), _c('td', {
      staticClass: "text-align-center hide-break-1"
    }, [(o.pathFirmado) ? [_c('span', {
      staticClass: "icon"
    }, [_c('i', {
      staticClass: "fa fa-check"
    })])] : [_c('span')]], 2), (_vm.perfil === 'recursos humanos') ? _c('td', {
      staticClass: "text-center flex fdc"
    }, [_c('a', {
      staticClass: "button is-small",
      attrs: {
        "href": o.pathContrato,
        "target": "_blank"
      }
    }, [_c('span', {
      staticClass: "icon is-small"
    }, [_c('i', {
      staticClass: "fa fa-paperclip is-small fs-12"
    })]), _c('span', [_vm._v("Ver adjunto")])]), _c('button', {
      staticClass: "button is-small is-danger mt-5",
      on: {
        "click": function($event) {
          return _vm.confirmacionEliminar(o)
        }
      }
    }, [_c('span', {
      staticClass: "icon is-small"
    }, [_c('i', {
      staticClass: "fa fa-trash fs-12"
    })]), _c('span', [_vm._v("Eliminar")])])]) : _vm._e()])
  }), 0)], 1) : _c('div', [_c('div', {
    staticClass: "message is-warning"
  }, [_c('div', {
    staticClass: "message-body"
  }, [_vm._v("No hay contratos que cumplan con los siguientes filtros")])])])])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "title"
  }, [_c('span', [_vm._v("Reporte de contratos")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-79709f32","hasScoped":true}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Component_Reporte_Contratos.vue
// module id = 917
// module chunks = 0